import { sendStats } from '../util/stats_endpoint'
import type { CompilerMeta } from 'types/unpoly/compiler'

up.compiler(
  '[data-stats]',
  { batch: true },
  (elements: HTMLElement[], _data: unknown[], meta: CompilerMeta) => {
    if (meta.revalidating) {
      return
    }

    const stats: Record<string, number[]> = {}

    for (const element of elements) {
      const attributes = JSON.parse(element.getAttribute('data-stats')!) as {
        type: string
        id: number
      }
      stats[attributes.type] = stats[attributes.type] || []
      stats[attributes.type].push(attributes.id)
    }

    sendStats(stats)
  },
)

up.compiler('[data-stats-click]', (element: HTMLElement) => {
  element.addEventListener('click', (event: MouseEvent) => {
    const clickedInsideOfLink = (event.target as Element).closest('a')
    if (clickedInsideOfLink) {
      const stats: Record<string, number[]> = {}
      const attributes = JSON.parse(element.getAttribute('data-stats-click')!) as {
        type: string
        id: number
      }
      stats[attributes.type] = stats[attributes.type] || []
      stats[attributes.type].push(attributes.id)
      sendStats(stats)
    } else {
      // no link clicked, no analytics should be sent
    }
  })
})
